<template>
  <v-app>
    <v-container class="text-center header-container">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="5" md="9" class="header-title">
          <!-- Title and Subtitle -->
          <img
            src="../assets/CVPR_Nashville_FinalLogo-removebg-preview.png"
            alt="Marvel40M+ Logo"
            class="header-logo"
          />

          <h1 class="gradient-text">           <img
            src="../assets/Marvel_CVPR.svg"
            alt="Marvel40M+ Logo"
            class="Mlogo"
          />arvel 40M+</h1>
          <p class="subtitle">
            Multi-Level and Domain-Specific 3D Captioning Dataset
          </p>
        </v-col>
        <v-col cols="12" sm="7">
          <v-responsive class="image-container">
            <img
              src="../assets/teaser.png"
              alt="Marvel40M+ Image"
              class="responsive-image"
            />
          </v-responsive>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "HeaderSection", // ✅ Fixed ESLint issue
};
</script>

<style scoped>
/* ===================== MONITOR VIEW ===================== */
.header-container {
  padding-top: 40px;
  color: white;
}
.gradient-text {
    font-size: 8rem;
    padding-top: 5px;
    padding-bottom: 3px;
  }
.header-logo {
  width: 13vw;
  object-fit: contain;
}

.responsive-image {
  width: 100%;
  object-fit: contain;
}

.Mlogo {
    width: 10vw;
  }
  .subtitle {
    font-size: 32px;
    padding-top: 30px;
    padding-bottom: 10px;
  }
/* ===================== MOBILE LANDSCAPE VIEW ===================== */
@media (max-width: 900px) and (max-height: 500px) and (orientation: landscape) {
  .header-container {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .header-logo {
    width: 20vw; /* Slightly bigger than portrait mode */
  }

  .responsive-image {
    width:100%;
  }

  .gradient-text {
    font-size: 2.5rem;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  .subtitle {
    font-size: 18px;
  }
}
/* ===================== MOBILE VIEW ===================== */
@media (max-width: 600px) {
  .header-logo {
    width: 60vw;
  }

  .responsive-image {
    width: 100%;
  }

  .gradient-text {
    font-size: 4rem;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  .subtitle {
    font-size: 20px;
  }

}

/* ============= Gradient Text Styling ============= */

.gradient-text {
    background: linear-gradient(to right, #0d47a1, #1976d2, #42a5f5, #90caf9);
    -webkit-background-clip: text; /* For WebKit browsers */
    background-clip: text; /* Standard property */
    color: transparent; /* Make the text color transparent to show gradient */
    font-size: 100px;
    animation: gradient-wave 20s linear infinite; /* Smooth infinite animation */
    background-size: 400% 100%; /* Larger gradient to ensure smooth looping */
}
@keyframes gradient-wave {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

.subtitle {
  color: rgb(92, 91, 91);
  font-size: 28px;
  text-align: center;
}
</style>
